<template>
  <form class="h-full flex flex-col gap-6" @submit.prevent="onSubmit">
    <button @click="goToBack" class="flex gap-2 text-primary-0 items-center">
      <i class="w-5" v-icon:arrow-left></i>
      {{ 'Volver al buscador' }}
    </button>
    <div class="flex-grow overflow-auto flex flex-col gap-6 h-1">
      <VMapFilterAccordion>
        <VMapFilterAccordionItem :index="0">
          <template #button>
            <div class="flex gap-2 items-center">
              <i class="w-5" v-icon:lightning></i>
              <h3 class="w-1 flex-grow font-nunito text-sm leading-snug font-bold">
                ¿Qué te mueve?
              </h3>
            </div>
          </template>
          <template #content>
            <ul class="grid grid-cols-4 gap-4">
              <li v-for="(price, index) in data.prices.options" :key="`price-${_uid}-${index}-${price.id}`">
                <label :for="`price-${_uid}-${price.id}`" class="custom-switch-map cursor-pointer">
                  <input :id="`price-${_uid}-${price.id}`" type="checkbox" name="prices" :value="price.id"
                    :checked="data.prices.value.includes(price.id)">
                  <span class="custom-switch-map-item">
                      <span class="custom-switch-map-item--switch"></span>
                  </span>
                  <span class="custom-switch-map-label">
                    {{ price.productName }}
                  </span>
                </label>
              </li>
            </ul>
          </template>
        </VMapFilterAccordionItem>
        <VMapFilterAccordionItem :index="1">
          <template #button>
            <div class="flex gap-2 items-center">
              <i class="w-5" v-icon:mosaic></i>
              <h3 class="w-1 flex-grow font-nunito text-sm leading-snug font-bold">
                ¿Qué servicios necesitas?
              </h3>
            </div>
          </template>
          <template #content>
            <ul class="grid grid-cols-3 gap-4">
              <li v-for="(service, index) in data.services.options" :key="`service-${_uid}-${index}-${service.code}`">
                <label :for="`service-${_uid}-${service.code}`"
                  class="custom-switch-map cursor-pointer">
                  <input :id="`service-${_uid}-${service.code}`" type="checkbox" name="services" :value="service.code"
                    :checked="data.services.value.includes(service.code)">
                  <span class="custom-switch-map-item">
                      <span class="custom-switch-map-item--switch"></span>
                  </span>
                  <span class="custom-switch-map-label">
                    {{service.name}}
                  </span>
                </label>
              </li>
            </ul>
          </template>
        </VMapFilterAccordionItem>
        <VMapFilterAccordionItem :index="2">
          <template #button>
            <div class="flex gap-2 items-center">
              <i class="w-5" v-icon:share></i>
              <h3 class="w-1 flex-grow font-nunito text-sm leading-snug font-bold">
                ¿Qué programas necesitas?
              </h3>
            </div>
          </template>
          <template #content>
            <ul class="grid grid-cols-3 gap-4">
              <li v-for="(program, index) in data.programs.options" :key="`program-${_uid}-${index}-${program.code}`">
                <label :for="`program-${_uid}-${program.code}`"
                  class="custom-switch-map cursor-pointer">
                  <input :id="`program-${_uid}-${program.code}`" type="checkbox" name="programs" :value="program.code"
                    :checked="data.programs.value.includes(program.code)">
                  <span class="custom-switch-map-item">
                      <span class="custom-switch-map-item--switch"></span>
                  </span>
                  <span class="custom-switch-map-label">
                    {{ program.name.includes('Vive') ? replaceWhitespace(program.name) : program.name}}
                  </span>
                </label>
              </li>
            </ul>
          </template>
        </VMapFilterAccordionItem>
      </VMapFilterAccordion>
    </div>
    <div class="flex flex-col gap-2">
      <button type="reset"
        class="border-t transition border-neutral-10 text-primary-0 hover:text-primary-dark-40 py-3 px-6 text-center underline w-full">
        Deshacer cambios
      </button>
      <button
        class="text-white transition bg-primary-0 hover:bg-primary-dark-40 py-3 px-6 text-center rounded-2xl w-full"
        type="submit">Aplicar filtro</button>
    </div>
  </form>
</template>

<script>
import VMapFilterAccordion from "./VMapFilterAccordion.vue"
import VMapFilterAccordionItem from "./VMapFilterAccordionItem.vue"
export default {
  name: "VMapFilters",
  props: ['data'],
  components: {
    VMapFilterAccordion,
    VMapFilterAccordionItem
  },
  methods: {
    replaceWhitespace(str){
      return str.replace(/\s/g,'');
    },
    goToBack() {
      this.$emit("go-to-back");
    },
    onSubmit({ target }) {
      const data = new FormData(target);
      this.$emit("apply-filters", {
        prices: data.getAll('prices'),
        services: data.getAll('services'),
        programs: data.getAll('programs')
      });
    }
  }
}
</script>

<style lang="scss" scoped></style>